<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo ? formData.orderNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.planStatus === 'Y' ||
            formData.planStatus === 'P' ||
            formData.planStatus === 'C' ||
            formData.planStatus === 'N'
              ? 'success'
              : formData.planStatus === 'T'
              ? 'warning'
              : formData.planStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_planStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>

        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName ? formData.createByName : '--' }} at
          {{ formData.createDate ? formData.createDate : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Review：{{ formData.reviewByName ? formData.reviewByName : '--' }} at
          {{ formData.reviewTime ? formData.reviewTime : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :disabled="disabled" size="small">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_title_plan_order_no') || '生产计划编号'"
          >
            <el-input
              v-model="formData.planOrderNo"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
          >
            <el-input
              v-model="formData.orderNo"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_planned_start_date') || '计划开始日期'"
          >
            <el-date-picker
              size="small"
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              v-model="formData.beginDate"
              type="datetime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_total_planned_quantity') || '总计划数量'"
          >
            <el-input
              v-model="formData.planQty"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_total_scheduled_production') || '已排产总数'"
          >
            <el-input
              v-model="formData.schedulingQty"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_total_completed') || '已完成总数'"
          >
            <el-input
              v-model="formData.finishQty"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_planned_end_date') || '计划结束日期'"
          >
            <el-date-picker
              size="small"
              style="width:100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              v-model="formData.endDate"
              type="datetime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-top: 10px">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane
          :label="$l('table_label_plan_product_details') || '生产计划产品明细'"
          name="order"
          lazy
        >
          <OrderDetail
            ref="order"
            :planOrderCode="planOrderCode"
            :disabled="disabled"
          />
        </el-tab-pane>
        <el-tab-pane
          :label="
            $l('table_label_plan_product_specification_details') ||
              '生产计划产品规格明细'
          "
          name="order_spec"
          lazy
        >
          <OrderSpecDetail
            ref="order"
            :planOrderCode="planOrderCode"
            :disabled="disabled"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import OrderDetail from '../order-detail'
import OrderSpecDetail from '../order-spec-detail'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { OrderDetail, OrderSpecDetail },
  mixins: [EditLoading],
  props: {
    planOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      activeName: 'order',

      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api
        .planOrderDetailApi({
          planOrderCode: this.planOrderCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
